import TimeMixin from '@/mixins/Time.js'
import SizesMixin from '@/mixins/Sizes.js'
import ScrollMixin from '@/mixins/Scroll.js'
import EventHubMixin from '@/mixins/EventHub.js'

import AppHeader from '@/components/app-header'
import AppGrid from '@/components/app-grid'
import AppGallery from '@/components/app-gallery'
import AppPlayer from '@/components/app-player'
import AppMusic from '@/components/app-music'
import AppLoader from '@/components/app-loader'
import AppLine from '@/components/app-line'
import AppCookiesBar from '@/components/app-cookies-bar'

import config from '@/config/index.js'

export default
{
    name: 'app-main',

    mixins:
    [
        TimeMixin,
        SizesMixin,
        ScrollMixin,
        EventHubMixin
    ],

    components:
    {
        AppHeader,
        AppGrid,
        AppGallery,
        AppPlayer,
        AppLoader,
        AppMusic,
        AppLine,
        AppCookiesBar
    },

    filters:
    {
        capitalize(_value)
        {
            if(!_value)
            {
                return ''
            }

            const value = _value.toString()

            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    data()
    {
        return {
            langsVisible: false,
            langsActive: false,
            pageTransitionDuration: 300
        }
    },

    watch:
    {
        $route()
        {
            // Page transition duration
            let duration = 300

            if(['stories', 'menu', 'chapters', '404'].indexOf(this.$route.meta.name) !== - 1 && this.firstTimeOnGrid)
            {
                duration = 1000
                this.firstTimeOnGrid = false
            }

            if(this.scroll.current > 0)
            {
                duration = 1000
            }

            if(this.$route.meta.name === 'chapter' && this.$root.$previousRoute.meta.name)
            {
                duration = 600
            }

            this.pageTransitionDuration = duration

            // Langs visible
            this.langsVisible = this.$route.meta.name === 'home' || this.$route.meta.name === 'menu' || this.sizes.width >= 768
        }
    },

    created()
    {
        this.firstTimeOnGrid = true

        // Set lang
        document.documentElement.setAttribute('lang', this.$route.meta.lang)

        // Platform classes
        if(config.platform.product)
        {
            document.documentElement.classList.add(`product-${config.platform.product.toLowerCase().replace(' ', '-')}`)
        }

        if(config.platform.os)
        {
            document.documentElement.classList.add(`os-${config.platform.os.toLowerCase().replace(' ', '-')}`)
        }

        document.documentElement.classList.add(config.platform.touch ? 'touch' : 'no-touch')
    },

    mounted()
    {
        // Langs
        if(this.$route.meta.name === 'home' || this.$route.meta.name === 'menu' || this.sizes.width > 768)
        {
            this.langsVisible = true
        }

        // Scroll lock
        this.$eventHub.$on('main.lockScroll', () =>
        {
            document.documentElement.classList.add('locked-scroll')
        })

        this.$eventHub.$on('main.unlockScroll', () =>
        {
            document.documentElement.classList.remove('locked-scroll')
        })
    },

    methods:
    {
        onPageLeave()
        {
            // Scroll top
            if(this.scroll.current > 0)
            {
                this.animateTo(0, this.pageTransitionDuration / 1000)
            }
        },

        onResize()
        {
            this.langsVisible = this.$route.meta.name === 'home' || this.sizes.width >= 768
        },

        onMainLangsClick(_event)
        {
            if(!this.langsActive)
            {
                _event.preventDefault()
                this.langsActive = true

                const callback = () =>
                {
                    window.setTimeout(() =>
                    {
                        this.langsActive = false

                        window.removeEventListener('mousedown', callback)
                        window.removeEventListener('touchstart', callback)
                    }, 100)
                }

                window.addEventListener('mousedown', callback)
                window.addEventListener('touchstart', callback)
            }
        },

        onMainLangsMouseEnter()
        {
            this.langsActive = true
        },

        onMainLangsMouseLeave()
        {
            this.langsActive = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-main/script.js